export default __webpack_public_path__ + "static/media/profile.95946939.jpg";